import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import useIsMobile from 'lib/useIsMobile';

import style from './index.scss';

const cx = classNames.bind(style);

export const Col = ({
  alignBottom,
  alignTop,
  centered,
  children,
  className,
  fullWidth,
  main,
  meta,
  padTop,
  ...props
}) => {
  const mobile = useIsMobile();
  if (mobile && meta) {
    return null;
  }
  const classes = cx({
    col: true,
    colBottom: alignBottom,
    colCentered: centered,
    colFullWidth: fullWidth,
    colPadTop: padTop,
    colTop: alignTop,
    main,
    mainMobile: main && mobile,
    meta,
  }, className);
  return (
    <div
      className={classes}
      {...props}
    >
      {meta
        ? (
          <div className={style.sticky}>
            {children}
          </div>
        )
        : children}
    </div>
  );
};

Col.propTypes = {
  alignBottom: PropTypes.bool,
  alignTop: PropTypes.bool,
  centered: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  main: PropTypes.bool,
  meta: PropTypes.bool,
  padTop: PropTypes.bool,
};

export const Row = ({
  centered,
  children,
  className,
  inner,
  innerBig,
  left,
  right,
  ...props
}) => (
  <div
    className={cx({
      row: true,
      rowCentered: centered,
      rowInner: inner,
      rowInnerBig: innerBig,
      rowLeft: left,
      rowRight: right,
    }, className)}
    {...props}
  >
    {children}
  </div>
);

Row.propTypes = {
  centered: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  inner: PropTypes.bool,
  innerBig: PropTypes.bool,
  left: PropTypes.bool,
  right: PropTypes.bool,
};
